import { ExtensibilityModeEnum } from 'owa-addins-types';

export interface PreviousNavigationState {
    hostItemIndex: string;
    mode: ExtensibilityModeEnum;
    isNullSent: boolean;
}

let previousNavigationState: PreviousNavigationState = getInitialPreviousNavigationState();

export function getPreviousNavigationState(): PreviousNavigationState {
    return previousNavigationState;
}

export function setPreviousNavigationState(prevState: PreviousNavigationState) {
    previousNavigationState = prevState;
}

function getInitialPreviousNavigationState(): PreviousNavigationState {
    return {
        hostItemIndex: null,
        mode: ExtensibilityModeEnum.Unknown,
        isNullSent: false,
    };
}
